import { AIAdminTracking } from 'app/modules/aiAdmin/components/aiAdminTracking/models';
import { U21TableColumn } from 'app/shared/u21-ui/components';

export const DEFAULT_AI_ADMIN_TRACKING_TABLE_COLUMNS: U21TableColumn<
  AIAdminTracking,
  any
>[] = [
  { id: 'id', accessor: 'id', Header: 'ID', type: 'text' },
  {
    id: 'org_id',
    accessor: 'org_id',
    Header: 'Organization ID',
    type: 'text',
  },
  {
    id: 'ai_investigations_result_id',
    accessor: 'ai_investigations_result_id',
    Header: 'AI investigation result ID',
    type: 'text',
  },
  {
    id: 'created_at',
    accessor: 'created_at',
    Header: 'Created at',
    type: 'datetime',
  },
  {
    id: 'updated_at',
    accessor: 'updated_at',
    Header: 'Updated at',
    type: 'datetime',
  },
  {
    id: 'group_id',
    accessor: 'group_id',
    Header: 'Group ID',
    type: 'text',
  },
  {
    id: 'framework',
    accessor: 'framework',
    Header: 'Framework',
    type: 'text',
  },
  {
    id: 'model_name',
    accessor: 'model_name',
    Header: 'Model',
    type: 'text',
  },
  {
    id: 'query_type',
    accessor: 'query_type',
    Header: 'Query type',
    type: 'text',
  },
  {
    id: 'tool_name',
    accessor: 'tool_name',
    Header: 'Tool name',
    type: 'text',
  },
  {
    id: 'prompt_version',
    accessor: 'prompt_version',
    Header: 'Prompt version',
    type: 'text',
  },
  {
    id: 'prompt_name',
    accessor: 'prompt_name',
    Header: 'Prompt name',
    type: 'text',
  },
  {
    id: 'tokens_used',
    accessor: 'tokens_used',
    Header: 'Tokens used',
    type: 'text',
  },
  {
    id: 'input_tokens',
    accessor: 'input_tokens',
    Header: 'Input tokens',
    type: 'text',
  },
  {
    id: 'output_tokens',
    accessor: 'output_tokens',
    Header: 'Output tokens',
    type: 'text',
  },
  {
    id: 'cost',
    accessor: 'cost',
    Header: 'Cost',
    type: 'text',
  },
  {
    id: 'latency_ms',
    accessor: 'latency_ms',
    Header: 'Latency (ms)',
    type: 'text',
  },
  {
    id: 'status',
    accessor: 'status',
    Header: 'Status',
    type: 'text',
  },
  {
    id: 'quality_score',
    accessor: 'quality_score',
    Header: 'Quality score',
    type: 'text',
  },
  {
    id: 'tags',
    accessor: 'tags',
    Header: 'Tags',
    type: 'list',
    disableSortBy: true,
  },
];
